import { useMemo, useEffect, useState } from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DataTable from "examples/Tables/DataTable";
import { useTranslation } from 'react-i18next';

function MatchViewSC({ tableData, title }) {
    const { t } = useTranslation();
    const dataTableData = {
        columns: [
            { Header: t(""), accessor: "g" },
            { Header: t("Female"), accessor: "fv" },
            { Header: t("Male"), accessor: "mv" },
        ],
        rows: tableData
    }

    return (
        <MDBox pt={0} pb={1}>
            <MDBox mb={1}>
                <Card>
                    <MDBox p={3} lineHeight={1} mb={0}>
                        <MDTypography variant="h5" fontWeight="medium">
                            {title}
                        </MDTypography>
                    </MDBox>
                    <DataTable
                        canSearch={false}
                        entriesPerPage={false}
                        showTotalEntries={false}
                        table={dataTableData} />
                </Card>
            </MDBox>
        </MDBox>
    );
};

MatchViewSC.propTypes = {
    tableData: PropTypes.array,
    title: PropTypes.string
};

export default MatchViewSC;